// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
// NOTE : For integrated multi-location practices, the location_id is the PARENT location id.
export var EventLocationType;
(function (EventLocationType) {
    EventLocationType["UNKNOWN_EVENT_LOCATION_TYPE"] = "UNKNOWN_EVENT_LOCATION_TYPE";
    EventLocationType["ONLINE"] = "ONLINE";
    EventLocationType["OFFICE"] = "OFFICE";
})(EventLocationType || (EventLocationType = {}));
export var EventLocationType_index;
(function (EventLocationType_index) {
    EventLocationType_index[EventLocationType_index["UNKNOWN_EVENT_LOCATION_TYPE"] = 0] = "UNKNOWN_EVENT_LOCATION_TYPE";
    EventLocationType_index[EventLocationType_index["ONLINE"] = 1] = "ONLINE";
    EventLocationType_index[EventLocationType_index["OFFICE"] = 2] = "OFFICE";
})(EventLocationType_index || (EventLocationType_index = {}));
// The Weave mapped Appointment status
export var EventStatus;
(function (EventStatus) {
    EventStatus["UNKNOWN_EVENT_STATUS"] = "UNKNOWN_EVENT_STATUS";
    EventStatus["UNCONFIRMED"] = "UNCONFIRMED";
    EventStatus["ATTEMPTED"] = "ATTEMPTED";
    EventStatus["CONFIRMED"] = "CONFIRMED";
    EventStatus["IN_OFFICE"] = "IN_OFFICE";
    EventStatus["COMPLETED"] = "COMPLETED";
    EventStatus["CANCELED"] = "CANCELED";
    EventStatus["NO_SHOW"] = "NO_SHOW";
})(EventStatus || (EventStatus = {}));
export var EventStatus_index;
(function (EventStatus_index) {
    EventStatus_index[EventStatus_index["UNKNOWN_EVENT_STATUS"] = 0] = "UNKNOWN_EVENT_STATUS";
    EventStatus_index[EventStatus_index["UNCONFIRMED"] = 1] = "UNCONFIRMED";
    EventStatus_index[EventStatus_index["ATTEMPTED"] = 2] = "ATTEMPTED";
    EventStatus_index[EventStatus_index["CONFIRMED"] = 3] = "CONFIRMED";
    EventStatus_index[EventStatus_index["IN_OFFICE"] = 4] = "IN_OFFICE";
    EventStatus_index[EventStatus_index["COMPLETED"] = 5] = "COMPLETED";
    EventStatus_index[EventStatus_index["CANCELED"] = 6] = "CANCELED";
    EventStatus_index[EventStatus_index["NO_SHOW"] = 7] = "NO_SHOW";
})(EventStatus_index || (EventStatus_index = {}));
export var EventType;
(function (EventType) {
    EventType["UNKNOWN_EVENT_TYPE"] = "UNKNOWN_EVENT_TYPE";
    EventType["APPOINTMENT"] = "APPOINTMENT";
    EventType["OUT_OF_OFFICE"] = "OUT_OF_OFFICE";
    EventType["REMINDER"] = "REMINDER";
    EventType["TRAINING"] = "TRAINING";
    EventType["BLOCK"] = "BLOCK";
    EventType["HOLIDAY"] = "HOLIDAY";
    EventType["VACATION"] = "VACATION";
    EventType["TODO"] = "TODO";
    EventType["BUSY"] = "BUSY";
    EventType["SICK"] = "SICK";
})(EventType || (EventType = {}));
export var EventType_index;
(function (EventType_index) {
    EventType_index[EventType_index["UNKNOWN_EVENT_TYPE"] = 0] = "UNKNOWN_EVENT_TYPE";
    EventType_index[EventType_index["APPOINTMENT"] = 1] = "APPOINTMENT";
    EventType_index[EventType_index["OUT_OF_OFFICE"] = 2] = "OUT_OF_OFFICE";
    EventType_index[EventType_index["REMINDER"] = 3] = "REMINDER";
    EventType_index[EventType_index["TRAINING"] = 4] = "TRAINING";
    EventType_index[EventType_index["BLOCK"] = 5] = "BLOCK";
    EventType_index[EventType_index["HOLIDAY"] = 6] = "HOLIDAY";
    EventType_index[EventType_index["VACATION"] = 7] = "VACATION";
    EventType_index[EventType_index["TODO"] = 8] = "TODO";
    EventType_index[EventType_index["BUSY"] = 9] = "BUSY";
    EventType_index[EventType_index["SICK"] = 10] = "SICK";
})(EventType_index || (EventType_index = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["UNSPECIFIED_ORDER"] = "UNSPECIFIED_ORDER";
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var SortOrder_index;
(function (SortOrder_index) {
    SortOrder_index[SortOrder_index["UNSPECIFIED_ORDER"] = 0] = "UNSPECIFIED_ORDER";
    SortOrder_index[SortOrder_index["ASC"] = 1] = "ASC";
    SortOrder_index[SortOrder_index["DESC"] = 2] = "DESC";
})(SortOrder_index || (SortOrder_index = {}));
